module.exports = "https://static.wagwalking.com/_next/static/images/banner-photo-wag-health-mobile_2x-aefc29e6b101c9dd11983bae3055f907.png";